<template>
  <el-dialog
    width="760px"
    class="profile-dialog"
    :visible.sync="showUserCenter"
    :show-close="false"
    :header="null"
    append-to-body
  >
    <div class="profile-header">
      <div class="profile-title">个人中心</div>
      <div class="close-btn" @click="handleClose" v-if="!showCompleteTips">
        <i class="el-icon-close"></i>
      </div>
    </div>
    <div class="profile-content">
      <div class="profile-left">
        <div class="profile-menu">
          <div
            class="menu-item"
            :class="{ active: activeMenu === 'account' }"
            @click="activeMenu = 'account'"
          >
            <i class="el-icon-user"></i>
            账号管理
          </div>
          <div
            class="menu-item"
            :class="{ active: activeMenu === 'privacy' }"
            @click="handleOpenLink('/user-protocol')"
          >
            <i class="el-icon-lock"></i>
            用户协议
          </div>
          <div
            class="menu-item"
            v-if="privateAuthUserList.includes(currentUser.username)"
            @click="handleOpenLink('/dashboard')"
          >
            <i class="el-icon-data-analysis"></i>
            运营看板
          </div>
                  <div
            class="menu-item"
            v-if="privateAuthUserList.includes(currentUser.username)"
            @click="handleOpenLink('/dashboard/configPage')"
          >
            <i class="el-icon-setting"></i>
            智能体配置
          </div>
          
          <div
            class="menu-item"
            v-if="privateAuthUserList.includes(currentUser.username)"
            @click="handleOpenLink('/dashboard/active-code')"
          >
            <i class="el-icon-tickets"></i>
            激活码管理
          </div>
        </div>
      </div>
      <div class="profile-right">
        <template v-if="activeMenu === 'account'">
          <el-alert
            v-if="showCompleteTips"
            title="请完善您的账号信息以使用完整服务"
            type="warning"
            show-icon
            :closable="false"
            @close="showCompleteTips = false"
            style="margin-bottom: 16px"
          />
          <div class="account-content">
            <div class="account-item">
              <div>用户名</div>
              <div>{{ currentUser.username }}</div>
            </div>
            <div class="account-item">
              <div>用户昵称</div>
              <div v-if="!showCompleteTips">{{ currentUser.nickname }}</div>
              <div v-else class="account-info-input">
                <el-input
                  v-model="nickname"
                  placeholder="请输入用户名"
                  maxlength="30"
                />
              </div>
            </div>
            <div class="account-item">
              <div>单位信息</div>
              <div v-if="!showCompleteTips">
                {{ currentUser.organizationName }}
              </div>
              <div v-else class="account-info-input">
                <el-input
                  v-model="organizationName"
                  :placeholder="
                    '请输入单位信息，至少' + orgnameLimitMin + '个字符'
                  "
                  maxlength="50"
                />
                <div
                  class="warning-tips"
                  v-if="
                    !organizationName.length ||
                    organizationName.length < orgnameLimitMin
                  "
                >
                  单位信息需在{{ orgnameLimitMin }}个字符以上
                </div>
              </div>
            </div>
            <!-- <div
              class="account-item"
              v-if="privateAuthUserList.includes(currentUser.username)"
            >
              <div>运营看板</div>
              <el-button
                type="primary"
                size="mini"
                plain
                @click="handleOpenLink('/dashboard')"
              >
                打开
              </el-button>
            </div>
            <div
              class="account-item"
              v-if="privateAuthUserList.includes(currentUser.username)"
            >
              <div>激活码管理</div>
              <el-button
                type="primary"
                size="mini"
                plain
                @click="handleOpenLink('/dashboard/active-code')"
              >
                打开
              </el-button>
            </div> -->
            <div class="account-item">
              <div>退出登录</div>
              <el-button type="danger" size="mini" plain @click="handleLogout">
                退出
              </el-button>
            </div>
            <div class="account-item-footer" v-if="showCompleteTips">
              <el-button
                type="primary"
                @click="handleSave"
                :disabled="
                  showCompleteTips &&
                  (!nickname ||
                    !organizationName ||
                    organizationName.length < orgnameLimitMin)
                "
              >
                保存并关闭
              </el-button>
            </div>
          </div>
        </template>
        <!-- <template v-else-if="activeMenu === 'settings'"></template>
          <div>通用设置内容</div>
        </template> -->
        <div
          v-loading="loading"
          style="width: 100%; height: 100%"
          v-else-if="activeMenu === 'privacy'"
        >
          <iframe
            ref="Iframe"
            style="width: 100%; height: 100%; border: none"
            src="https://xt12366.cn/%E7%A8%8E%E6%94%B6%E6%95%B0%E5%AD%97%E5%8C%96%E5%AE%9E%E8%AE%AD%E5%B9%B3%E5%8F%B0%E7%94%A8%E6%88%B7%E5%8D%8F%E8%AE%AE.html"
          ></iframe>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { privateAuthUserList } from "@/config";
import { getUserMessage, modifyUserMessage } from "@/api/login";
export default {
  name: "Profile",
  data() {
    return {
      activeMenu: "account",
      nickname: "",
      organizationName: "",
      orgnameLimitMin: 4,
      privateAuthUserList,
      loading: false,
      showCompleteTips: false,
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.user.userInfo || {};
    },
    showUserCenter() {
      return this.$store.state.user.showUserCenter;
    },
    showLogin() {
      return this.$store.state.user.showLogin;
    },
  },
  watch: {
    activeMenu(newVal) {
      if (newVal === "privacy") {
        this.$nextTick(() => {
          this.iframeLoad();
        });
      }
    },
    showLogin(newVal) {
      if (!newVal) {
        if (this.currentUser.userId) {
          this.handleGetUserInfo(this.currentUser.userId);
        }
      }
    },
  },
  mounted() {
    const loginInfo = localStorage.getItem("userInfo");
    if (loginInfo) {
      const _loginInfo = JSON.parse(loginInfo);
      if (_loginInfo.userId) {
        this.$store.dispatch("user/setUserInfo", _loginInfo);
        this.handleGetUserInfo(_loginInfo.userId);
      }
    }
  },
  methods: {
    async handleSave() {
      try {
        await modifyUserMessage({
          userId: this.currentUser.userId,
          nickname: this.nickname,
          organizationName: this.organizationName,
        });
        this.handleGetUserInfo(this.currentUser.userId);
        this.showCompleteTips = false;
        this.$store.dispatch("user/setUserCenterVisible", false);
      } catch (error) {
        console.error("Failed to update user info:", error);
        this.$message.error("用户信息更新失败");
      }
    },
    async handleGetUserInfo(userId) {
      try {
        const res = await getUserMessage({
          userId: userId,
        });
        if (res) {
          this.nickname = res.nickname || "";
          this.organizationName = res.organizationName || "";
          this.$store.dispatch("user/setUserInfo", res);
          this.handleNeedCompleteInfo(res);
        }
      } catch (error) {
        console.error("Failed to fetch user info:", error);
      }
    },
    handleNeedCompleteInfo(userInfo) {
      if (
        !userInfo.organizationName ||
        userInfo.organizationName.length < this.orgnameLimitMin
      ) {
        this.showCompleteTips = true;
        this.$store.dispatch("user/setUserCenterVisible", true);
        return;
      }
    },
    handleClose() {
      this.$store.dispatch("user/setUserCenterVisible", false);
    },
    handleOpenLink(path) {
      const resolvedPath = this.$router.resolve({ path });
      window.open(resolvedPath.href, "_blank");
    },
    async handleLogout() {
      try {
        this.$store.dispatch("user/logout");
        this.handleClose();
        if (!this.$route.path.includes("/landing")) {
          this.$router.push({ path: "/" });
        } else {
          window.location.reload();
        }
      } catch (error) {
        console.error("Logout failed:", error);
      }
    },
    iframeLoad() {
      this.loading = true;
      const iframe = this.$refs.Iframe;
      // 兼容处理
      if (iframe.attachEvent) {
        // IE
        iframe.attachEvent("onload", () => {
          this.loading = false;
        });
      } else {
        // 非IE
        iframe.onload = () => {
          this.loading = false;
        };
      }
    },
  },
};
</script>
<style lang="less" scoped>
.profile-dialog {
  /deep/.el-dialog {
    border-radius: 10px;
  }
  /deep/.el-dialog__header {
    display: none;
  }
  /deep/.el-dialog__body {
    padding: 0;
  }
}
.profile-header {
  height: 70px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  .profile-title {
    font-weight: 500;
    font-size: 16px;
    color: #333333;
  }
  .close-btn {
    font-weight: 400;
    padding: 4px 10px;
    transition: all 0.2s;
    font-size: 14px;
    color: #888888;
    cursor: pointer;
    border-radius: 6px;
    background: #f5f5f5;
    &:hover {
      transform: translateY(1px);
    }
  }
}
.profile-content {
  width: 760px;
  height: 410px;
  background: #ffffff;
  border-radius: 10px;
  display: flex;
  padding: 0 24px 16px 16px;
  box-sizing: border-box;
  .profile-left {
    width: 180px;
    height: 100%;
    display: flex;
    flex-direction: column;
    .profile-menu {
      display: flex;
      flex-direction: column;
      gap: 2px;
      .menu-item {
        height: 40px;
        user-select: none;
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 0 6px;
        box-sizing: border-box;
        font-size: 14px;
        color: #333333;
        cursor: pointer;
        border-radius: 6px;
        transition: all 0.2s;
        &:not(.active):hover {
          background: #f5f5f5;
        }
      }
      .active {
        background: #f2f3f4;
      }
    }
  }
  .profile-right {
    flex: 1;
    height: 100%;
    box-sizing: border-box;
    padding-left: 20px;
    .account-content {
      display: flex;
      flex-direction: column;
      .account-item {
        height: 68px;
        position: relative;
        border-bottom: 1px solid #ebebeb;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        .account-info-input {
          position: relative;
          width: 220px;
          .warning-tips {
            position: absolute;
            bottom: -15px;
            right: 0;
            font-size: 10px;
            color: #ff4d4f;
          }
        }
      }
      .account-item-footer {
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
}
</style>
